import React, { useContext } from "react";
import logo from "../Images/logo.gif";
import { Link, useNavigate } from "react-router-dom";
import runContext from "../Context/RunContext";
import Client from "./Client";
import { toast } from "react-hot-toast";
import { useLocation } from "react-router-dom";



export default function Navbar({ others }) {
  const { clients } = useContext(runContext);
  const reactNavigator = useNavigate();
  const location = useLocation();

  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem("authtoken");
    localStorage.removeItem("username");
    reactNavigator("/");
  };
  async function invite() {
    try {
      await navigator.clipboard.writeText(location.pathname.split("/")[2]);
      toast.success("Copied to Clipboard");
    } catch (err) {
      toast.error("Could not copy the Room ID");
    }
  }
  function onLeave(){
    reactNavigator("/")
  }
  return (
    <>
      <nav id="main-nav">
        <div className="logo">
          <img src={logo} alt="logo" srcSet="" />
          <div className="nav-mid">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About us</Link>
            </li>
            <li>
              <Link to="/contact">Contact us</Link>
            </li>
          </div>
        </div>
        {location.pathname.split("/")[1] === "editor" ? (
          <div className="client-div">
            {clients && clients.map((client) => {
              return (
                <Client key={client.socketId} username={client.username} />
              );
            })}
          </div>
        ) : (
          ""
        )}

        {location.pathname.split("/")[1] === "editor"?
            <div>
          <button className=" HomeButtons invite" onClick={invite}>
            Invite
          </button>
          <button className=" HomeButtons leave" onClick={onLeave}>
            Leave
          </button>
          </div>:""
        }
        <div className="other">
          {localStorage.getItem("authtoken") ? (
            <div>
              <Link to="/">
                <button className="HomeButtons" onClick={handleLogout}>
                  Logout
                </button>
              </Link>
            </div>
          ) : (
            <div>
              <Link to="/sign-up">
                <button className="HomeButtons">Sign up</button>
              </Link>
              <Link to="/login">
                <button className="HomeButtons">Log in</button>
              </Link>
            </div>
          )}
        </div>
      </nav>
    </>
  );
}
